import { useState, useEffect } from 'react'

export function useUserCity(fallback = 'Local') {
  const [city, setCity] = useState<string | null>(null) // null = still loading
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetch('https://freeipapi.com/api/json')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.cityName && data.cityName !== '-') {
          setCity(data.cityName)
          setIsLoading(false)
        } else {
          throw new Error('No city')
        }
      })
      .catch(() => {
        fetch('https://ipwho.is/')
          .then((res) => res.json())
          .then((data) => {
            if (data && data.city && data.success) {
              setCity(data.city)
              setIsLoading(false)
            } else {
              throw new Error('No city')
            }
          })
          .catch(() => {
            fetch('https://ipapi.co/json/')
              .then((res) => res.json())
              .then((data) => {
                if (data && data.city && !data.error) {
                  setCity(data.city)
                } else {
                  setCity(fallback)
                }
                setIsLoading(false)
              })
              .catch(() => {
                setCity(fallback)
                setIsLoading(false)
              })
          })
      })
  }, [])

  return { city: city ?? fallback, isLoading }
}
